import { LastColdStartFailedToRun } from 'src/common/helpers/error-code';
import { ILoginUser } from 'src/common/interfaces/dtos/ILoginUser';
import { LocalStorage } from '../../common/helpers/local-storage';
import { touchpointRegister } from './service/touchpoint-register';

export const registerTouchpoint = async (
  userName: string,
  password: string,
  touchpointId: string,
  businessUnitId?: string,
): Promise<void> => {
  LocalStorage.clearLocalStorage(['storedBaseUrl', 'uiConfiguration', 'userPref']);

  let registerId: string | undefined;
  const loginUser: ILoginUser = {
    userName: userName,
    password: password,
  };

  await touchpointRegister(loginUser, touchpointId, businessUnitId)
    .then((data): void => {
      registerId = data.computerName;
    })
    .catch(
      async (err): Promise<void> => {
        if (err.code === LastColdStartFailedToRun) {
          const shouldThrow = false;
          // process ColdStart, get shouldThrow
          if (shouldThrow) {
            throw err;
          }
          registerId = (await touchpointRegister(loginUser, touchpointId, businessUnitId))
            .computerName;
        } else {
          throw err;
        }
      },
    );

  setComputerName(registerId ?? '');
};

const setComputerName = (registrationId: string): void => {
  LocalStorage.setComputerName(registrationId);
};
